import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = () => ({
  root: {
    minWidth: 330,
  },
  content: {
    width: '100%',
  },
});

const OutcomeLauncher = ({
  className,
  classes,
}) => {
  const { resource } = useMetaLayoutContext(); // onSubmit
  const { displayErrorMessage } = useSnackbarContext();
  const { loadModalCollectionByLink } = useModalContext();

  const onChange = async (value) => {
    resource.attr('outcomeType', value);
    try {
      const coll = await resource.submit();
      const res = coll.resources().head();
      loadModalCollectionByLink(res.relationship(fr.relationships.wizard.name).link('related').url());
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaControlField
        attr={'outcomeType'}
        resource={resource}
        // onChange={onSubmit} // TODO: refactor nav endpoint to just return the wizard
        onChange={onChange}
      />
    </Box>
  );
};

OutcomeLauncher.defaultProps = {
  className: '',
};

OutcomeLauncher.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OutcomeLauncher);
